import React from 'react';
import { isPublicPrivateAssetGrowthBlock, withSuspense } from 'venn-utils';
import { useRecoilValue } from 'recoil';
import { blockLimitedRequestSubjects, blockSettings } from 'venn-state';
import { Warning } from 'venn-ui-kit';

/** Warning message about block needing private and public subjects. */
export const NeedsPublicPrivateMessage = withSuspense(null, ({ selectedBlockId }: { selectedBlockId: string }) => {
  const limitedSubjects = useRecoilValue(blockLimitedRequestSubjects(selectedBlockId));
  const blockType = useRecoilValue(blockSettings(selectedBlockId)).customBlockType;

  if (!isPublicPrivateAssetGrowthBlock(blockType) || limitedSubjects.length >= 2) {
    return null;
  }

  return <Warning text="Your Subject Group must include one Returns-Based subject and one Private Asset subject." />;
});
